import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IMaintenanceService } from "services/MaintenanceService";
import { CPLMaintenanceDatesModel } from "services/api/cplauthapi/CPLAuthAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { isDateInPast } from "cpl-react-common/Helpers/DateHelpers";

type InitialState = {
  ConnectMaintenanceDate: Date | null;
};

const initialState: InitialState = {
  ConnectMaintenanceDate: null,
};

export const maintenanceSlice = createSlice({
  name: "maintenance",
  initialState,
  reducers: {
    setCPLMaintenanceDates: (state, action: { payload: CPLMaintenanceDatesModel }) => {
      const { cplConnectMaintenanceDate } = action.payload;
      state.ConnectMaintenanceDate = cplConnectMaintenanceDate ?? null;
    },
  },
});

export const checkMaintenanceDates = createAsyncThunk("maintenance/CheckMaintenanceDates", async () => {
  const maintenanceService = container.get<IMaintenanceService>(SERVICE_TYPES.CPLAuthMaintenanceClient);
  maintenanceService.checkMaintenanceDates();
});

export const { setCPLMaintenanceDates } = maintenanceSlice.actions;
export const selectConnectMaintenanceDate = (state: RootState) => state.maintenance.ConnectMaintenanceDate;
export const selectDownForMaintenance = (state: RootState) => {
  const { ConnectMaintenanceDate } = state.maintenance;

  return isDateInPast(ConnectMaintenanceDate);
};

export default maintenanceSlice.reducer;
